/* eslint-disable import/prefer-default-export */
export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (typeof window.IntersectionObserver === 'undefined') {
    // eslint-disable-next-line
    require('intersection-observer');
  }
};
